import { Icon, Spinner } from '@innovationnorway/cl-react';
import React from 'react';
import { EventDetailsDto, EventDtoV2 } from 'src/api/v2';
import { formatAsCurrencyString } from 'src/utils/FormatValue';
import { useTranslation } from 'react-i18next';
import Divider from 'src/components/Divider';
type Props = {
  event: EventDtoV2;
  eventDetails?: EventDetailsDto;
  eventStatus?: 'completed' | 'upcoming' | 'active' | '';
  isFetching?: boolean;
};
const EventCardStats: React.FC<Props> = ({ event, eventDetails, eventStatus, isFetching }) => {
  const { t: tCommon } = useTranslation('common');
  const { t: tSelfEffort } = useTranslation('selfEffort');
  if (isFetching) {
    return (
      <div className="display--flex justify-content--center">
        <Spinner aria-label={tCommon('loading')} />
      </div>
    );
  }

  const rowClassName = 'padding-x--2 display--flex align-items--center gap--2';

  return (
    <div className="display--flex flex-direction--column gap--1 font-size--smaller">
      {eventStatus !== 'upcoming' ? (
        <>
          <span className={rowClassName}>
            <Icon prefix="fasr" iconName="user" size="xs" className="color--red-100" />
            {eventDetails?.participants ? eventDetails.participants : 0}{' '}
            {tCommon('participants').toLowerCase()}
          </span>
          <Divider />
          <span className={rowClassName}>
            <Icon prefix="fasr" iconName="calendar-edit" size="xs" className="color--red-100" />
            {eventDetails?.timeEntryHours ? eventDetails.timeEntryHours : 0} {tSelfEffort('hoursRegistered')}
          </span>
          <Divider />
          <span className={rowClassName}>
            <Icon prefix="fasr" iconName="sack-dollar" size="xs" className="color--red-100" />
            {formatAsCurrencyString(
              eventDetails?.inKindTotal ? eventDetails.inKindTotal : 0,
              ' ',
              undefined,
              0,
              undefined,
              ',-',
            )}{' '}
            {tCommon('inkind').toLowerCase()}
          </span>
        </>
      ) : (
        <>
          <span className={rowClassName}>
            <Icon prefix="fasr" iconName="map-marker-alt" size="xs" className="color--red-100" />
            {event.location}
          </span>
          <Divider />
          <span className={rowClassName}>
            <Icon prefix="fasr" iconName="clock" size="xs" className="color--red-100" />
            {event.duration} {tCommon('hours')}
          </span>
        </>
      )}
    </div>
  );
};
export default EventCardStats;
